import { render } from "./FeedblocksView.vue?vue&type=template&id=46dc7e2e"
import script from "./FeedblocksView.vue?vue&type=script&lang=js"
export * from "./FeedblocksView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mmessick/Sites/kiosk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__